import styled from 'styled-components';

export const StyledSignIn = styled.div`
  position: relative;

  .si-wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 150px;

    &-left {
      width: 476px;
      max-height: 628px;
      padding: 75px 67px 47px;
      border-radius: 20px;
      background:
        linear-gradient(
          164.98deg,
          rgba(85, 107, 237, 0.74) -5.02%,
          rgba(55, 150, 226, 0.74) 26.72%,
          rgba(69, 169, 157, 0.74) 58.93%,
          rgba(127, 208, 243, 0.74) 95%
        ),
        linear-gradient(0deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0));
      box-shadow: 0px 4px 35px 0px #00000014;

      &-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 314px;
        height: 52px;
        margin: 0 auto 42px;

        > img {
          border-radius: 4px;
          opacity: 1;

          &:first-child {
            width: 95px;
            height: 79px;
          }

          &:last-child {
            width: 152px;
            height: 28px;
          }
        }
      }

      &-middle {
        .logo {
          margin-bottom: 14px;
        }
      }

      &-bottom {
        margin-top: 54px;

        &-top {
          margin-bottom: 22px;
          color: var(--color-white);
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 28px;

          > span {
            cursor: pointer;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: var(--color-white);

            &:first-child {
              position: relative;

              &:after {
                content: '';
                position: absolute;
                right: -15px;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 12px;
                background: var(--color-white);
              }
            }
          }
        }

        &-middle {
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          white-space: nowrap;
          color: var(--color-white);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;

          > span {
            color: var(--color-white);

            &:first-child {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
`;

export const StyledSignInRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: 'Poppins', sans-serif;

  p {
    margin: 0;
    white-space: nowrap;
    color: var(--color-white);
  }

  .project-title {
    margin-top: -40px;
    font-weight: 600;
    font-style: normal;
    font-size: 32px;
    line-height: 100%;
    letter-spacing: 0%;
  }

  .welcome {
    margin-top: 29px;

    p {
      font-weight: 600;
      font-style: normal;
      font-size: 37px;
      line-height: 100%;
      letter-spacing: 0%;

      &:last-child {
        margin-top: 5px;
      }
    }
  }

  .tagline {
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    margin-top: 72px;

    p {
      font-weight: 500;
      font-style: normal;
      line-height: 100%;
      letter-spacing: 0%;
    }

    .en {
      font-size: 29px;
    }

    .ar {
      align-self: flex-end;
      margin-top: 16px;
      font-size: 28px;
      text-align: right;
    }
  }

  @media (max-width: 1280px) {
    display: none;
  }
`;
